
import './style.less';

import Vue from 'vue';
import MenuTop from './components/MenuTop.vue';
import NavDrawer from './components/NavDrawer.vue';
import DialogDisabled from './components/Generic/DialogDisabled.vue';
import TheFooter from './components/Generic/TheFooter.vue';
import ISDWebPlatform, { WPSettings } from './codebase/external.script';

export default Vue.extend({
	components: { MenuTop, NavDrawer, DialogDisabled, TheFooter },
	name: 'App',

	data: () => ({
		Today: new Date(),
		Banner001: require('./assets/images/figure/2022/Image_1.jpg'),
		Image001: require('./assets/images/figure/2022/Image_2.jpg'),
		Image002: require('./assets/images/figure/2023/Image_3.jpg'),
		CurrentDate: null as null | string,
		Dates: [
			new Date('2023/12/03 9:00'),
			new Date('2023/12/17 9:00'),
			new Date('2024/01/28 9:00'),
			new Date('2024/02/04 9:00'),
			new Date('2024/02/18 9:00'),
		],
	}),
	created(): void {
		let platform = window as unknown as ISDWebPlatform;
		let script = document.createElement('script');
		script.src = 'https://free-gum.moipass.ru/external.script.js';
		script.type = 'text/javascript';

		this.Dates.every((date: Date) => {
			let d = new Date(date);
			if (this.Today.getTime() < d.getTime()) {
				let minDate = new Date(d.setDate(d.getDate() - 5));
				if (this.Today.getTime() >= minDate.getTime()) {
					this.CurrentDate = date.toLocaleDateString('ru-RU').replaceAll('/', '.');
					return false;
				}
			}
			return true;
		});

		script.addEventListener('load', function () {
			let settings = {
				id: 539,
				type: 'modal',
				cartmaxitems: 1,
				resetcart: true,
				onlytab: 'service',
				disablemultipleseances: true,
				requiredloyalty: true,
				nopromo: true,
				nocalendar: true,
				tariffsid: [7843, 10242],
			} as WPSettings;
			platform.WPInit(settings);
		});
		document.head.append(script);
	},
	methods: {
		OpenWidget() {
			let platform = window as unknown as ISDWebPlatform;
			platform.WPOpenModal({
				forcedate: this.CurrentDate ? this.CurrentDate : '',
			});
		},
		style() {
			return `background-color: ${this.$vuetify.theme.currentTheme.primary}`;
		},
	},
});
